<template>
    <div id="app">
      <img alt="Vue logo" src="../assets/logo.png"  style="height:220px;">
    <van-tabs>
        <van-tab title="密码登录">
          <van-form validate-first @failed="onFailed" @submit="onSubmit">
            <van-field
              v-model="mobile"
              name="mobile"
              label="手机号码"
              placeholder="请输入手机号码"
              :rules="[{ validator:mobileValidator, required: true, message: '请输入正确手机号码' }]"
            />
            <van-field
              v-model="password"
              name="password"
              label="密码"
              placeholder="密码位手机后6位"
              type="password"
              :rules="[{ validator:passwordValidator, required: true, message: '长度6-18位字符串类型：数字、英文、特殊符号且必须包含数字及英文' }]"
            />
            <div style="margin: 16px;">
              <van-button round block type="info" native-type="submit">登录</van-button>
            </div>
          </van-form>
        </van-tab>
      </van-tabs>
     没有账号？<router-link to="register">去注册</router-link>
    </div>
  </template>
  
  <script>
  
  export default {
    name: 'App',
    components: {
    },
    data() {
      return {
        mobile: '',
        verifyCode: '',
        password: '',
        active: 1,
        // 是否已经发送了验证码
        isSmsSend: false,
        // 文本
        sendBtnText: '点击发送验证码',
        // 计时器对象
        timer: null,
        // 倒数120秒
        counter: 120
      };
    },
    methods: {
      onSubmit(values) {
        var vue = this
        var sk = this.$md5(values.password)
        var date = new Date().toUTCString()
        var strToSign = `x-date: ${date}`
        var hmac = this.$crypto.createHmac('sha256', sk)
        var signature = hmac.update(strToSign).digest('base64')
        var authorization = `hmac username="${values.mobile}", algorithm="hmac-sha256", headers="x-date", signature="${signature}"`
        this.$axios
        .get(vue.$url + '/v1/user/login', {
            headers: {
             'Content-Type': 'application/json',
             'X-Date': date,
             'X-Authorization': authorization
          }
        })
        .then(response => {
          console.log(response)
          vue.$router.push('/')
        })
        .catch(function (error) { // 请求失败处理
          vue.$dialog.alert({
            message: error.response.data.message,
          })
        })
  
      },
      onFailed(errorInfo) {
        console.log('failed', errorInfo);
      },
      // 校验函数返回 true 表示校验通过，false 表示不通过
      mobileValidator(val) {
        return /^1[3456789]\d{9}$/.test(val);
      },
      passwordValidator(val) {
        return true
       // return /^(?=.*\d)(?=.*[a-zA-Z])[\da-zA-Z~!@#$%^&*]{6,18}$/.test(val);
      },
      sendSmsCode() {
        // 判断手机号是否已经输入
        console.log(this.form)
        if (!this.mobileValidator(this.mobile)) {
          return false
        }
        // 调用接口，发送短信验证码
        // 这部分放调用发送短信的接口，这里先不做任何功能，主要先把按钮倒计时的功能实现
        // 将按钮禁用，防止再次点击
        this.isSmsSend = true
        // 开始倒计时，60s之后才能再次点击
        this.countDown()  // 这里实现倒计时的功能，文章下面开始介绍
      },
      countDown () {
        // 将setInterval()方法赋值给前面定义的timer计时器对象，等用clearInterval()方法时方便清空这个计时器对象
        this.timer = setInterval(() => {
          // 替换文本，用es6里面的``这个来创建字符串模板，让秒实时改变
          this.sendBtnText = `(${this.counter}秒)后重新发送`
          this.counter--
          if (this.counter < 0) {
            // 当计时小于零时，取消该计时器
            clearInterval(this.timer)
          }
        }, 1000)
      },
    },
  }
  </script>
  
  <style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  
  }
  </style>
  